import { CheckedCheckBox, UncheckedCheckBox } from "@iventis/styles/src/components";
import { Theme } from "@emotion/react";
import { Content } from "@iventis/translations/content/typed-content";
import { Checkbox, useTheme } from "@mui/material";
import React, { FunctionComponent } from "react";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { DescriptiveText } from "@iventis/components/src/enum-to-radio-buttons";

export const TimeEstimateCheckbox: FunctionComponent<{
    checked: boolean;
    onChange: (value) => void;
}> = ({ checked, onChange }) => {
    const theme = useTheme<Theme>();
    const translate = useIventisTranslate();
    return (
        <div className="checkbox-input">
            <Checkbox
                checked={checked}
                icon={<UncheckedCheckBox size={15} borderStyle={`1px solid ${theme.typographyColors.subdued}`} backgroundColour={theme.secondaryColors.blank} />}
                checkedIcon={
                    <CheckedCheckBox
                        size={15}
                        tickColour={theme.shades.two}
                        borderStyle={`1px solid ${theme.typographyColors.subdued}`}
                        backgroundColour={theme.secondaryColors.blank}
                    />
                }
                color="default"
                onChange={onChange}
                style={{ padding: "0px", alignSelf: "start" }}
            />
            <DescriptiveText>{translate(Content.schedule.scheduled_item.estimated_duration_description)}</DescriptiveText>
        </div>
    );
};
